<template>
  <div id="app">
    <template v-if="$route.path === '/login'">
      <router-view></router-view>
    </template>
    <template v-else>
      <el-container>
        <!-- 侧边栏 -->
        <el-aside width="240px" class="sidebar">
          <div class="logo-container">
            <div class="logo">
              <i class="el-icon-notebook-2"></i>
              <span>华华备忘录</span>
            </div>
          </div>
          <el-menu :default-active="activeMenu" router class="el-menu-vertical" background-color="#1a2332"
            text-color="#b0c4de" active-text-color="#ffffff" :unique-opened="true" :collapse-transition="false">
            <el-menu-item index="/notes" class="menu-item">
              <i class="el-icon-tickets"></i>
              <span slot="title">记事</span>
            </el-menu-item>
            <el-menu-item index="/items" class="menu-item">
              <i class="el-icon-goods"></i>
              <span slot="title">物品</span>
            </el-menu-item>
            <el-menu-item index="/item-types" class="menu-item">
              <i class="el-icon-menu"></i>
              <span slot="title">物品分类</span>
            </el-menu-item>
            <el-menu-item index="/logs" class="menu-item">
              <i class="el-icon-document"></i>
              <span slot="title">操作日志</span>
            </el-menu-item>
            <el-menu-item index="/statistics" class="menu-item">
              <i class="el-icon-data-analysis"></i>
              <span slot="title">数据统计</span>
            </el-menu-item>
            <el-menu-item index="/system-setting" class="menu-item">
              <i class="el-icon-setting"></i>
              <span slot="title">系统设置</span>
            </el-menu-item>
          </el-menu>
        </el-aside>

        <!-- 主内容区 -->
        <el-container>
          <el-header class="header">
            <div class="header-left">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{ currentRouteName }}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="header-right">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  <el-avatar :size="35"
                    src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
                  <span class="username">{{ username }}</span>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="$router.push('/user-center')">个人中心</el-dropdown-item>
                  <el-dropdown-item @click.native="$router.push('/system-setting')">设置</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button type="text" @click="handleLogout" class="logout-btn">
                <i class="el-icon-switch-button"></i>
              </el-button>
            </div>
          </el-header>

          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { logout as apiLogout } from '@/api/login'

export default {
  name: 'App',
  computed: {
    ...mapState('user', ['userInfo']),
    activeMenu() {
      return this.$route.path
    },
    currentRouteName() {
      return this.$route.name
    },
    username() {
      // 从 Vuex 状态中获取用户名，如果不存在则使用本地存储中的用户名，否则显示默认值
      return (this.userInfo && this.userInfo.userName) || localStorage.getItem('userName') || '管理员'
    }
  },
  watch: {
    // 监听路由变化，确保用户信息是最新的
    '$route'() {
      // 当路由发生变化时，强制更新计算属性
    }
  },
  methods: {
    ...mapActions('user', ['logout']),
    async handleLogout() {
      try {
        await apiLogout()
      } catch (e) {
        console.log(e)
      }
      this.logout()
      // 清除本地存储的用户信息
      localStorage.removeItem('userName')
      localStorage.removeItem('isAdmin')
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss">
@use "@/assets/styles/main.scss" as *;

body,
html,
#app {
  margin: 0;
  padding: 0;
  height: 100vh;
}

.el-container {
  height: 100vh;
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

.el-aside.sidebar {
  height: 100vh;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  left: 0;
  top: 0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

#app {
  overflow: hidden;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.sidebar {
  background: #1a2332;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;

  .logo-container {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(74, 118, 168, 0.3);
    background: rgba(74, 118, 168, 0.2);

    .logo {
      font-size: 20px;
      font-weight: bold;
      color: #ffffff;
      display: flex;
      align-items: center;
      
      i {
        margin-right: 12px;
        font-size: 24px;
        color: #4fc3f7;
      }
    }
  }

  .el-menu {
    border-right: none;
    margin-top: 10px;
    background-color: transparent !important;
  }

  .menu-item {
    height: 50px;
    line-height: 50px;
    margin: 5px 10px;
    border-radius: 8px;
    transition: all 0.3s ease;
    color: #b0c4de;
    background-color: rgba(74, 118, 168, 0.1);

    &.is-active {
      background: linear-gradient(90deg, #4fc3f7 0%, #2196f3 100%) !important;
      color: #ffffff !important;
      box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
    }

    &:hover {
      background-color: rgba(74, 118, 168, 0.3);
      color: #ffffff !important;
    }

    i {
      color: inherit;
      margin-right: 12px;
      font-size: 18px;
      width: 24px;
      text-align: center;
    }
    
    span {
      font-size: 15px;
    }
  }
}

.header {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  padding: 0 20px;

  .header-left {
    .el-breadcrumb {
      font-size: 16px;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    
    .el-dropdown-link {
      display: flex;
      align-items: center;
      cursor: pointer;

      .username {
        margin-left: 12px;
        font-size: 15px;
        font-weight: 500;
        color: #333;
      }
    }
    
    .logout-btn {
      margin-left: 25px;
      font-size: 22px;
      color: #666;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: all 0.3s;
      
      &:hover {
        color: #F56C6C;
        background-color: #fdeeee;
      }
    }
  }
}

.el-main {
  background-color: #f5f7fa;
  padding: 20px;
}
</style>